module.exports = __webpack_public_path__ + "img/lsh.138a4c68.png";